// extracted by mini-css-extract-plugin
export default {"content":"Ef5Egq"};